import Axios from 'axios';
import history from 'src/utils/history';

const axiosInstances = ({ baseURL, headers, withCredentials = true }) => {
  const instance = Axios.create({
    baseURL,
    headers,
    withCredentials
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        if (window.location.pathname !== '/403') {
          // Use client-side navigation so the app shell (redux store,
          // Five9 iframe/session, log panel) is preserved. `window.location.href`
          // would trigger a full browser reload and lose everything.
          history.push('/403');
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default axiosInstances;
